import { useTranslation } from 'react-i18next'

const FEATURE_ICONS = [
  '\u{1F6E1}\uFE0F',
  '\u23F1\uFE0F',
  '\u{1F517}',
  '\u{1F465}',
  '\u{1F4DC}',
  '\u{1F514}',
]

export function FeaturesSection() {
  const { t } = useTranslation()

  const features = [
    {
      icon: FEATURE_ICONS[0],
      title: t('features.encryption.title'),
      desc: t('features.encryption.desc'),
    },
    {
      icon: FEATURE_ICONS[1],
      title: t('features.countdown.title'),
      desc: t('features.countdown.desc'),
    },
    {
      icon: FEATURE_ICONS[2],
      title: t('features.blockchain.title'),
      desc: t('features.blockchain.desc'),
    },
    {
      icon: FEATURE_ICONS[3],
      title: t('features.multiBeneficiary.title'),
      desc: t('features.multiBeneficiary.desc'),
    },
    {
      icon: FEATURE_ICONS[4],
      title: t('features.smartContracts.title'),
      desc: t('features.smartContracts.desc'),
    },
    {
      icon: FEATURE_ICONS[5],
      title: t('features.notifications.title'),
      desc: t('features.notifications.desc'),
    },
  ]

  return (
    <section id="features" className="px-4 py-16 max-md:py-12 md:px-8 md:py-24">
      <div className="max-w-content mx-auto text-center">
        <span className="border-accent/20 bg-accent-muted text-accent mb-6 inline-block rounded-full border px-4 py-1.5 text-xs font-semibold tracking-widest uppercase">
          {t('features.badge')}
        </span>
        <h2 className="text-fg mb-12 text-[clamp(1.375rem,3vw,2.25rem)] font-bold max-md:mb-8">
          {t('features.heading')}
        </h2>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,300px),1fr))] gap-6 max-md:gap-4">
          {features.map((f) => (
            <div
              key={f.title}
              className="border-line bg-gradient-card duration-base hover:border-accent/20 hover:bg-surface-card-hover rounded-xl border p-8 text-left transition-all hover:-translate-y-0.5 hover:shadow-md max-md:p-6"
            >
              <span className="bg-accent-muted mb-4 inline-flex h-11 w-11 items-center justify-center rounded-lg text-[1.35rem]">
                {f.icon}
              </span>
              <h3 className="text-fg mb-2 text-[1.0625rem] font-semibold">
                {f.title}
              </h3>
              <p className="text-fg-secondary text-sm leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
